import { useStep3FlatKeysInform } from './useStep3.flatKeysInform'
import useActivationObject from '../../../providers/ActivationObjectProvider/hooks/useActivationObject'
import { useStep3Props, Step3Props } from '../types'
import useStep3FormConditions from './useStep3.form.conditions'
import useStep3FormOptions from './useStep3.form.options'
import useStep3Form from './useStep3.form'

const useStep3 = (props: useStep3Props): Step3Props => {
    const { data: activationObject, isUpdating } = useActivationObject()
    const formProps = useStep3Form(activationObject)
    const options = useStep3FormOptions(formProps.form, activationObject)
    const conditionsProps = useStep3FormConditions(formProps.form, options, activationObject)
    const flatKeysInformProps = useStep3FlatKeysInform(formProps.form)

    return {
        ...props,
        activationObject,
        form: formProps,
        options: options,
        conditions: conditionsProps,
        flatKeysInformProps,
        isUpdating,
    }
}

export default useStep3
